import _ from 'lodash';
import { Link } from 'react-router-dom';
import { useApi } from '../../services/api';
import { toast } from 'react-toastify';
import React, { useState, useEffect, Fragment } from 'react';
import {
  Grid,
  Cell,
  Card,
  Toolbar,
  DataTable,
  TableHeader,
  TableBody,
  TableRow,
  TextField,
  TableColumn,
  ListItem,
  MenuButton,
  FontIcon,
  Button,
  DialogContainer,
  TablePagination
} from 'react-md';
import Axios from 'axios';
const env = process.env;

export default props => {
  let profile = JSON.parse(localStorage.profile);

  const [user, setUser] = useState({});
  const [usersSliced, setUserSliced] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [, users, fetchUser] = useApi('auth', 'user', []);
  const [, , fetchDelete] = useApi('auth', 'user', {}, 'delete');
  const [asending, setAsending] = useState({
    name: false,
    email: false,
    'address.city': false,
    'address.state': false
  });
  const [, data, doFetch] = useApi('auth', 'user', {}, 'post');

  const checkToken = async () => {
    Axios.defaults.headers.common['Authorization'] = localStorage.token;
    // const response = await Axios.get('http://localhost:3002/token');
    const response = await Axios.get(env['REACT_APP_AUTH'] + '/token');
    if (!response.data.valid) {
      localStorage.clear();
      props.setLogged(false);
      setTimeout(() => {}, 1000);
    }
    props.reload(response.data.version);
    return response.data.valid;
  };

  useEffect(() => {
    async function tttt() {
      if (await checkToken()) {
        fetchUser();
      }
    }
    tttt();
  }, []);

  useEffect(() => {
    setUserSliced(users.slice(0, 10));
  }, [users]);

  const sort = culumn => {
    let sort = _.orderBy(
      [...users],
      [culumn],
      [!asending[culumn] ? 'asc' : 'desc']
    );
    setUserSliced([...sort]);
    setAsending({ ...asending, [culumn]: !asending[culumn] });
  };

  const filter = (v, filterBy) => {
    if (!v.length) {
      setUserSliced(users);
    } else {
      setUserSliced(
        users.filter(u => u[filterBy].toLowerCase().includes(v.toLowerCase()))
      );
    }
  };

  return (
    <Fragment>
      <Grid className="grid-example">
        <Cell desktopOffset={2} size={8}>
          <Card>
            <Toolbar
              colored
              title="Users"
              actions={
                <Button
                  component={Link}
                  to="/user/"
                  tooltipLabel="Add User"
                  style={{ marginTop: '30px' }}
                  secondary
                  floating
                >
                  add
                </Button>
              }
            ></Toolbar>
            <DataTable baseId="123" plain>
              <TableHeader>
                <TableRow>
                  <TableColumn
                    sorted={asending['name']}
                    onClick={() => sort('name')}
                  >
                    Name
                  </TableColumn>
                  <TableColumn
                    sorted={asending['email']}
                    onClick={() => sort('email')}
                  >
                    Email
                  </TableColumn>
                  <TableColumn>Phone</TableColumn>
                  <TableColumn
                    sorted={asending['isActivated']}
                    onClick={() => sort('isActivated')}
                  >
                    Active
                  </TableColumn>
                  {profile.role === 'support' ? (
                    <TableColumn>Reset password</TableColumn>
                  ) : null}
                  <TableColumn />
                </TableRow>
              </TableHeader>
              <TableHeader>
                <TableRow key={0}>
                  <TableColumn>
                    {' '}
                    <TextField
                      id="name"
                      onChange={v => filter(v, 'name')}
                      leftIcon={<FontIcon>filter_list</FontIcon>}
                    />
                  </TableColumn>
                  <TableColumn>
                    {' '}
                    <TextField
                      id="email"
                      onChange={v => filter(v, 'email')}
                      leftIcon={<FontIcon>filter_list</FontIcon>}
                    />
                  </TableColumn>
                  <TableColumn>
                    {' '}
                    <TextField
                      id="addresscity"
                      onChange={v => filter(v, 'phone')}
                      leftIcon={<FontIcon>filter_list</FontIcon>}
                    />
                  </TableColumn>
                  <TableColumn></TableColumn>
                  <TableColumn></TableColumn>
                </TableRow>
              </TableHeader>
              <TableBody>
                {usersSliced.map((s, i) => (
                  <TableRow key={i}>
                    <TableColumn>{`${s.name} ${
                      s.lastName ? s.lastName : ''
                    }`}</TableColumn>
                    <TableColumn>{s.email}</TableColumn>
                    <TableColumn>{s.phone}</TableColumn>
                    <TableColumn>
                      {s.isActivated ? 'Active' : 'Inactive'}
                    </TableColumn>
                    {profile.role === 'support' ? (
                      <TableColumn>
                        <Button
                          flat
                          secondary
                          onClick={async () => {
                            if (
                              window.confirm(
                                'are you sure to want reset this password?'
                              )
                            ) {
                              let body = s;

                              let [result, error] = await doFetch({
                                body: body
                              });
                              if (!error) {
                                props.history.push('/users/list');
                                toast.success('Password succesfully reseted');
                              } else {
                                toast.error(
                                  'Please check data before save user.'
                                );
                              }
                            }
                          }}
                        >
                          Reset password
                        </Button>
                      </TableColumn>
                    ) : null}
                    <TableColumn>
                      <MenuButton
                        id="menu"
                        icon
                        menuItems={[
                          <ListItem
                            key={1}
                            primaryText="Edit"
                            rightIcon={<FontIcon>edit</FontIcon>}
                            onClick={() => {
                              props.history.push(`/user/${s._id}`);
                            }}
                          />,
                          <ListItem
                            key={2}
                            primaryText="Delete"
                            rightIcon={<FontIcon>delete</FontIcon>}
                            onClick={() => {
                              setUser(s);
                              setShowModal(true);
                            }}
                          />
                        ]}
                        centered
                      >
                        more_vert
                      </MenuButton>
                    </TableColumn>
                  </TableRow>
                ))}
              </TableBody>
              <TablePagination
                rows={users.length}
                rowsPerPageLabel={'Rows'}
                onPagination={(s, rpp) =>
                  setUserSliced(users.slice(s, s + rpp))
                }
                className={'footertTable'}
              />
            </DataTable>
          </Card>
        </Cell>
      </Grid>
      <DialogContainer
        id="speed-boost"
        visible={showModal}
        title="Do you want to permanently delete this user?"
        actions={[
          {
            secondary: true,
            children: 'Delete',
            onClick: async () => {
              await fetchDelete({ params: [user._id] });
              await fetchUser({});
              setShowModal(false);
              toast.success('User has been deleted.');
            }
          },
          {
            primary: true,
            children: 'Cancel',
            onClick: () => {
              setShowModal(false);
            }
          }
        ]}
        onHide={() => {}}
      ></DialogContainer>
    </Fragment>
  );
};
